export function isIOS() {
  return (
    navigator.userAgent.includes('iPhone') || // iPhone safari, chrome, firefox
    (navigator.userAgent.includes('Macintosh') &&
      navigator.maxTouchPoints > 0) || // iPad safari, firefox
    navigator.userAgent.includes('iPad') // iPad chrome
  );
}
